<template>
  <div class="container">
    <div v-if="showNoModel" style="text-align:center;margin-bottom:20px">
      <img src="@/assets/暂无搜索内容.jpg" alt="" style="width:200px" />
    </div>
    <section style="padding-bottom: 30px" v-else>
      <!-- <div style="height: 120px; margin-bottom: 30px"></div> -->
      <el-row :gutter="30" class="content" style="margin: 0">
        <waterfall
          :col="5"
          :width="itemWidth"
          :gutterWidth="gutterWidth"
          :data="modelList"
          :loadDistance="100"
        >
          <div v-for="(items, index) in modelList" :key="index">
            <el-card
              class="box-card"
              shadow="always"
              :body-style="{ padding: '0px' }"
            >
              <el-image
                class="image"
                :src="items.imgUrl"
                fit="cover"
                style="cursor: pointer"
                @click="getModelDetalis(index)"
              ></el-image>
              <el-tag class="mdfree" effect="plain">
                {{ items.attributeCn }}
              </el-tag>
              <div style="padding: 15px; cursor: pointer">
                <h4 class="mdTitle" @click="getModelDetalis(index)">
                  {{ items.modelName | ellipsis
                  }}<span class="mdTime">{{ items.time }}</span>
                </h4>
                <p class="mdDetail" @click="getModelDetalis(index)">
                  {{ items.typeFirstName }}-{{ items.typeSecondName }}
                </p>
                <div class="mpNum">
                  <span
                    ><a
                      ><i class="el-icon-view" style="margin-right: 8px"></i
                      >{{ items.accessNum }}</a
                    ></span
                  >
                  <span v-if="!items.hasLiked"
                    ><a href="javascript:void(0)"
                      ><i class="el-icon-star-off" style="margin-right: 8px"></i
                      >{{ items.collectionNum }}</a
                    ></span
                  >
                  <span v-if="items.hasLiked"
                    ><a href="javascript:void(0)"
                      ><i class="el-icon-star-on" style="margin-right: 8px"></i
                      >{{ items.collectionNum }}</a
                    ></span
                  >
                  <span
                    ><a href="javascript:void(0)"
                      ><i
                        class="el-icon-chat-dot-square"
                        style="margin-right: 8px"
                      ></i
                      >{{ items.commentsNum }}</a
                    ></span
                  >
                </div>
                <div class="mpFooter" @click="getDesigner(items.creatorUuid)">
                  <div>
                    <el-avatar
                      size="medium"
                      :src="
                        items.designerHead === null
                          ? require('@/assets/headportrait.png')
                          : items.designerHead
                      "
                    ></el-avatar>
                  </div>
                  <span style="flex: 1; margin-left: 8px; font-size: 12px">{{
                    items.designerName
                  }}</span>
                  <div>
                    <el-button @click="getModelDetalis(index)">
                      <i class="el-icon-download el-icon--right"></i>
                      {{ items.downNum }}
                    </el-button>
                  </div>
                </div>
              </div>
            </el-card>
          </div>
        </waterfall>
      </el-row>
    </section>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { queryModelList, designerByUserId } from "@/utils/interface";
import { getHumanDate } from "@/utils/date";

export default {
  data() {
    return {
      modelList: [],
      showNoModel: false,
    };
  },

  computed: {
    ...mapState({
      isTokenDoor: "isTokenDoor",
      isLogin: "isLogin",
      isUsermessage: "isUsermessage",
    }),
    itemWidth() {
      return 224;
      //rem布局 计算列宽度
      //可以根据自己的rem设置修改这里的 334 值
    },
    gutterWidth() {
      return 20;

      //rem布局 计算x轴方向margin(y轴方向的margin自定义在css中即可)

      //可以根据自己的rem设置修改这里的 36 值
    },
  },
  filters: {
    ellipsis (value) {
      if (!value) return ''
      if (value.length > 8) {
        return value.slice(0,8) + '...'
      }
      return value
    }
  },
  created() {
    this.getModelList();
  },
  methods: {
    getModelList() {
      let param = {
        isLogin: this.isLogin ? 1 : 0,
        order: "DESC",
        status: "RELEASED",
        orderBy: "COLLECTION",
        current: 1,
        pageSize: 10,
      };
      queryModelList(param).then((res) => {
        if (res != null && res.list != null && res.list.length > 0) {
          res.list.map((item) => {
            item.time = getHumanDate(new Date(item.createDate).getTime(), true);
          });
          this.modelList = res.list;
          this.modelList.length > 0
            ? (this.showNoModel = false)
            : (this.showNoModel = true);
        } else {
          this.showNoModel = true;
        }
      });
    },
    getDesigner(uuid) {
      designerByUserId(uuid).then((res)=>{
          let routeData = this.$router.resolve({
              name: "designModel",  params: {uuid: res.uuid}
          });
          window.open(routeData.href, "_blank");
      })
    },
    // 点击前往详情页
    getModelDetalis(i) {
      let routeData = this.$router.resolve({
        name: "modelDetails",
        query: {
          uuid: this.modelList[i].uuid,
        },
      });
      window.open(routeData.href, "_blank");
    },
  },
};
</script>

<style scoped lang="less">
.container {
  width: 1200px;
  margin: 0 auto;

  /deep/ .vue-waterfall {
    overflow-y: unset;
    overflow-x: unset;
  }
}
/deep/ .el-card {
  border-radius: 0px !important;
  border: 1px solid #ebeef559;
}
.box-card {
  margin-bottom: 20px;
  position: relative;
  width: 224px;
  //   border-radius: 6px;

  .image {
    width: 100%;
    display: block;
  }

  .mdfree {
    position: absolute;
    top: 10px;
    left: 10px;
    opacity: 0.6;
    border: none;
    line-height: 20px;
    height: 20px;
    width: 40px;
    text-align: center;
    padding: 0;
    color: #157efb;
  }
}
.mdTitle {
  font-size: 16px;
  font-weight: normal;
  color: rgba(0, 0, 0, 0.85);
  margin-bottom: 10px;

  span.mdTime {
    font-size: 12px;
    float: right;
    margin-top: 5px;
    color: #808080 !important;
  }
}
.mdDetail {
  font-size: 12px;
  margin-top: 10px;
  color: #808080;
}
.mpNum {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  cursor: default;
  span {
    display: inline-block;
    width: 50%;
    text-align: center;
    font-size: 12px;
    height: 50px;
    line-height: 50px;
  }

  span a {
    color: #808080;
    cursor: default;
  }

  span a:hover {
    color: rgba(21, 126, 251, 0.8);
  }
}

.mpFooter {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid #ebeef5;
  margin: 0 -21px -15px;
  padding: 10px 20px;

  /deep/ .el-button {
    color: #157efb;
    border-color: #157efb;
    padding: 6px 10px;
    font-size: 12px;
  }
}
.content {
  /deep/ .el-col-4 {
    width: 20%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/activity/components/activemodelList.vue